import type React from 'react';
import { useCallback } from 'react';

import { TagSearchableDropdown } from '../../../../../../components/tag-dropdown/tag-searchable-dropdown';

import type { WorkflowActionInputProps } from '../../../registries/registry-types';

export const TagDropdown: React.FC<WorkflowActionInputProps> = ({ draft, onUpdate }) => {
  const handleChange = useCallback(
    (tagId: string) => {
      onUpdate({ intParameter: tagId ? Number(tagId) : null });
    },
    [onUpdate],
  );

  return <TagSearchableDropdown onChange={handleChange} value={draft.intParameter?.toString() ?? ''} />;
};
